export let Org = {
    path: 'org',
    name: 'org',
    meta: {
        roleCode: '002',
    },
    component: () =>
        import ( /* webpackChunkName: "org-page" */ '@/views/back-stage/organization/org-page.vue'),
    children: [{
            path: 'members',
            name: 'org-members',
            meta: {
                roleCode: '00201',
            },
            component: () =>
                import (
                    /* webpackChunkName: "members-management" */
                    '@/views/back-stage/organization/members-management.vue'
                ),
        },
        {
            path: 'disableaccount',
            name: 'disable-account',
            meta: {
                roleCode: '00202',
            },
            component: () =>
                import (
                    /* webpackChunkName: "disable-account" */
                    '@/views/back-stage/organization/disable-account.vue'
                ),
        },
        {
            path: 'orgtype',
            name: 'org-type',
            meta: {
                roleCode: '00203',
            },
            component: () =>
                import (
                    /* webpackChunkName: "org-type" */
                    '@/views/back-stage/organization/org-type.vue'
                ),
        },
        {
            path: 'orgrole',
            name: 'org-role-1',
            meta: {
                roleCode: '00204',
            },
            component: () =>
                import (
                    /* webpackChunkName: "org-role" */
                    '@/views/back-stage/organization/org-role.vue'
                ),
        },
        {
            path: 'orgsync',
            name: 'org-sync',
            component: () =>
                import (
                    /* webpackChunkName: "org-sync" */
                    '@/views/back-stage/organization/org-sync.vue'
                ),
        },
        {
            path: 'fieldset',
            name: 'field-set',
            meta: {
                roleCode: '00205',
            },
            component: () =>
                import (
                    /* webpackChunkName: "field-set" */
                    '@/views/back-stage/organization/field-set.vue'
                ),
        },
        {
            path: '*',
            redirect: 'members',
        },
    ],
};
